import { Outlet } from 'react-router-dom';
import type { ReactNode } from 'react';

// material-ui
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Toolbar from '@mui/material/Toolbar';

// project imports
import Footer from './components/Footer';
import Header from './components/Header';

type AuthLayoutProps = {
  children?: ReactNode;
};

export default function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <Box sx={{ height: '100vh', overflow: { xs: 'auto', md: 'hidden' }, bgcolor: 'grey.50', display: 'flex', flexDirection: 'column' }}>
      <Header simple />
      <Toolbar sx={{ minHeight: 74 }} />
      <Container
        maxWidth={false}
        disableGutters
        sx={{
          flexGrow: 1,
          display: 'flex',
          alignItems: 'stretch',
          minHeight: { xs: 'auto', md: 0 },
          overflow: { xs: 'visible', md: 'hidden' },
          pb: '42px'
        }}
      >
        {children ?? <Outlet />}
      </Container>
      <Footer centered />
    </Box>
  );
}
